import React from 'react';
import PropTypes from 'prop-types';
import { Column, Row } from '@pella/sash-framework';
import { Image } from '../../../';

const PackagePanel = ({ data }) => (
	<div className='packagePanel'>
		{data.options_title && <h3>{data.options_title}</h3>}
		{data.description && (
			<div
				className='mb-4'
				dangerouslySetInnerHTML={{ __html: data.description }}
			/>
		)}

		{data.package?.[0] && (
			<Row verticalGutters>
				{data.package.map((item, index) => (
					<Column
						xs={12}
						md={6}
						key={index}
					>
						<div className='h-full border border-gray-15 p-2.5'>
							<Row align='center'>
								{item.image?.[0]?.image?.url && (
									<Column xs='auto'>
										<Image
											data={{ file: item.image[0].image }}
											className='h-[100px] w-[100px]'
										/>
									</Column>
								)}

								<Column xs='fluid'>
									{item.heading && <p className='mb-1 text-lg font-semibold md:text-xl'>{item.heading}</p>}
									{item.description && <div dangerouslySetInnerHTML={{ __html: item.description }} />}
								</Column>
							</Row>
						</div>
					</Column>
				))}
			</Row>
		)}
	</div>
);

PackagePanel.propTypes = {
	data: PropTypes.object.isRequired,
};

export default PackagePanel;
